import { Spinner } from "./ui/spinner";

export function Loader({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner>{children}</Spinner>
    </div>
  );
}
